<template>
  <modal :clickToClose="false" :scrollable="false" name="custom-confirm" ref="dialog">
    <!--    <div class="confirm-wrap">-->
    <div class="custom-message">{{ message }}</div>
    <div class="confirm-box">
      <button @click="confirm" class="confirm-button">확인</button>
      <button @click="cancel" class="cancel-button">취소</button>
    </div>
    <!--    </div>-->
  </modal>
</template>

<script>
import { enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'CustomConfirm',
  data() {
    return {
      element: null
    }
  },
  computed: {
    message() {
      return this.$store.getters['modal/getConfirmMessage']()
    },
    confirmMethod() {
      return this.$store.getters['modal/getConfirmMethod']()
    }
  },
  mounted() {
    this.element = document.getElementsByClassName('v--modal-overlay')
  },
  methods: {
    close() {
      enableBodyScroll(this.element[0])
      // this.$bodyScrollUnLock()
      this.$modal.hide('custom-confirm')
    },
    cancel() {
      this.$store.commit('modal/setIsConfirmed', false)
      this.close()
    },
    confirm() {
      this.$store.commit('modal/setIsConfirmed', true)
      if (this._.isFunction(this.confirmMethod)) {
        this.confirmMethod()
      }
      this.close()
    }
  }
}
</script>

<style>
.v--modal-overlay[data-modal='custom-confirm'] .v--modal-box {
  display: flex;
  padding: 24px 24px 20px 24px;
  flex-direction: column;
  justify-content: space-between;
}

.v--modal-background-click {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* width: 100vw !important;
    height: 100vh !important; */
  /* padding: 60px; */
  box-sizing: border-box;
}

.vue-dialog {
  left: 0 !important;
  top: 0 !important;
}

/* .dialog-content {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    padding-top: 24px !important;
    padding-bottom: 24px !important;
    font-size: 14px !important;
  }
  .vue-dialog-buttons {
  }
  .vue-dialog-button {
    font-size: 14px !important;
    font-weight: 400 !important;
    height: 45px !important;
  }
  .v--modal-box {
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: auto !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  } */
.confirm-box {
  display: flex;
  margin-top: 60px;
  flex-direction: row-reverse;
}

.confirm-box button {
  color: #269c98;
  font-size: 16px;
  letter-spacing: -0.3px;
  width: 62px;
  text-align: right;
}

.confirm-box button.confirm-button {
}

.confirm-box button.cancel-button {
}
</style>
